const order = ["NEW YORK SLIM FIT", "TOKYO SLIM FIT", "NEW YORK CLASSIC FIT", "TOKYO CLASSIC FIT", "NEW YORK UNTUCKED CASUAL", "TOKYO UNTUCKED CASUAL", "NEW YORK SLIM FIT (For One Piece Collar)", "TOKYO SLIM FIT (For One Piece Collar)"];

// Body一覧並び替え
let bodySort = (id, bodyList) => {
  if (bodyList.length > 0) {
    let bodyListName = [];
    for (let i=0; i<bodyList.length; i++) {
      bodyListName.push(bodyList[i].name);
    }
    let deleteList = bodyListName.filter(i => order.indexOf(i) == -1);
    let displayList = bodyList;
    for (let i=0; i<displayList.length; i++) {
      displayList = displayList.filter(n => n.name !== deleteList[i]);
    }
    const sortBodyList = displayList.sort(function(x, y) { return order.indexOf(x.name) - order.indexOf(y.name); });
    const elementBodyList = document.getElementById(id);
    let htmlBodyList = '';
    for (let i=0; i<sortBodyList.length; i++) {
      if (sortBodyList[i].available == 'true') {
        htmlBodyList = htmlBodyList.concat('<div class="body-item"><a href="' + sortBodyList[i].url + '" class="body-item-link">' + sortBodyList[i].name + '</a></div>');
      }
    }
    if (htmlBodyList == '') {
      htmlBodyList = 'no available'
    }
    elementBodyList.innerHTML = htmlBodyList;
  }
}
